import i18n from '@/lang/i18n'
import CellGridRichText from '@/components/common/CellGridRichText'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export default function() {
    return [
        {
            type: AgGridColumnType.MASTER_DETAIL,
            colId: 'expand.registry'
        },
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: 'text',
            field: 'casenumber',
            headerName: i18n.tc('grid.casCasenumber')
        },
        {
            type: AgGridColumnType.COMMON_CASE_STATUS,
            field: 'status',
            headerName: i18n.tc('grid.detail.casStatusId')
        },
        {
            type: 'associatedCases',
            field: 'associatedCases',
            headerName: i18n.tc('grid.detail.associatedCases')
        },
        {
            type: 'text',
            field: 'laboratory.labName',
            headerName: i18n.tc('grid.detail.laboratory')
        },
        {
            type: 'text',
            field: 'physicianDepartment.name',
            headerName: i18n.tc('grid.detail.requestingUnit')
        },
        {
            type: 'text',
            field: 'physicianPetitioner.fullName',
            headerName: i18n.tc('grid.detail.requestingProfessional')
        },
        {
            type: 'text',
            field: 'destinationDepartment.name',
            headerName: i18n.tc('grid.detail.destinationUnit')
        },
        {
            type: 'text',
            field: 'casAttn',
            headerName: i18n.tc('grid.detail.receiver')
        },
        {
            type: 'text',
            field: 'pathologist.fullName',
            headerName: i18n.tc('grid.detail.patName')
        },
        {
            type: 'text',
            field: 'clinicalData',
            headerName: i18n.tc('grid.detail.relevantClinicalData')
        },
        {
            type: 'text',
            field: 'notes',
            headerName: i18n.tc('grid.detail.observations'),
            cellStyle: { 'white-space': 'normal' },
            cellRendererFramework: CellGridRichText,
            cellClass: 'patient-cases',
            autoHeight: true
        },
        {
            type: 'text',
            field: 'comprehensiveDiagnosis.text',
            headerName: i18n.tc('grid.detail.comprehensiveDiagnosis'),
            cellStyle: { 'white-space': 'normal' },
            cellRendererFramework: CellGridRichText,
            minWidth: 480,
            autoHeight: true
        },
        {
            type: 'text',
            headerName: i18n.t('registry.btn.consultation'),
            headerTooltip: i18n.t('registry.btn.consultation'),
            colId: 'grid.caseOfReference',
            field: 'grid.caseOfReference',
            hide: false,
            filter: false,
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-glasses')
            },
            cellRenderer: (data) => {
                if (data.value) {
                    if (data.value === true) {
                        return '<i class="success far fa-check"/>'
                    }
                }
                return ''
            },
            exportField: 'caseOfReference',
            exportType: 'boolean'
        },
        {
            type: ['dateTime', 'fixedWidth'],
            headerName: i18n.t('grid.reqRequestDate'),
            colId: 'requestDate',
            field: 'requestDate',
            exportField: 'requestDate',
            exportType: 'dateTime'
        },
        {
            type: ['dateTime', 'fixedWidth'],
            headerName: i18n.tc('grid.casRegistrationDate'),
            colId: 'registrationDate',
            field: 'registrationDate',
            exportField: 'registrationDate',
            exportType: 'dateTime'
        },
        {
            type: ['dateTime', 'fixedWidth'],
            headerName: i18n.tc('grid.casValidationDate'),
            colId: 'validationDate',
            field: 'validationDate',
            exportField: 'validationDate',
            exportType: 'dateTime'
        },
        {
            type: 'text',
            headerName: i18n.t('global.externalReference'),
            colId: 'externalReference',
            field: 'externalReference',
            exportField: 'externalReference',
            exportType: 'text'
        },
        {
            type: 'text',
            headerName: i18n.t('grid.headerName.requestLabel'),
            colId: 'requestLabel',
            field: 'requestLabel',
            exportField: 'requestLabel',
            exportType: 'text'
        }
        // TODO Esperando endpoints de backend
        /*
        {
            headerName: i18n.tc('global.request'),
            colId: 'request',
            children: [
                {
                    type: 'text',
                    headerName: i18n.tc('global.id'),
                    colId: 'reqExternalId',
                    field: 'reqExternalId',
                    width: 110,
                    suppressSizeToFit: true,
                    onCellClicked: onIdClicked
                }, {
                    type: AgGridColumnType.COMMON_REQUEST_STATUS,
                    headerName: i18n.tc('global.status'),
                    colId: 'reqStatusId',
                    field: 'reqStatusId'
                }, {
                    type: ['dateTime', 'fixedWidth'],
                    headerName: i18n.tc('grid.reqRequestDate'),
                    colId: 'reqRequestDate',
                    field: 'reqRequestDate'
                }, {
                    type: ['dateTime', 'fixedWidth'],
                    headerName: i18n.tc('grid.casRegistrationDate'),
                    colId: 'caseStudy.casRegistrationDate',
                    field: 'caseStudy.casRegistrationDate'
                }, {
                    type: ['dateTime', 'fixedWidth'],
                    headerName: i18n.tc('grid.casValidationDate'),
                    colId: 'caseStudy.casValidationDate',
                    field: 'caseStudy.casValidationDate'
                }, {
                    type: 'requestPriority',
                    headerName: i18n.tc('global.priority'),
                    colId: 'priority.level',
                    field: 'priority.level'
                }
            ]
        }, {
            headerName: i18n.tc('global.patient'),
            colId: 'patient',
            children: [
                {
                    type: 'text',
                    headerValueGetter: () => store.getters.parameters.global?.mainPatientIdentifierType.name,
                    field: 'patient.personIdentifier',
                    colId: 'patient.personIdentifier',
                    sortable: false,
                    filterParams: {
                        filterOptions: ['equals'],
                        defaultOption: 'equals',
                        newRowsAction: 'keep'
                    }
                }, {
                    type: 'text',
                    headerValueGetter: () => store.getters.parameters.global?.secondaryPatientIdentifierType.name,
                    field: 'patient.centerIdentifier',
                    colId: 'patient.centerIdentifier',
                    sortable: false,
                    filterParams: {
                        filterOptions: ['equals'],
                        defaultOption: 'equals',
                        newRowsAction: 'keep'
                    }
                }, {
                    type: 'text',
                    headerName: i18n.tc('grid.patName'),
                    field: 'patient.patName',
                    colId: 'patient.patName'
                }, {
                    type: 'text',
                    headerName: i18n.tc('grid.patMiddleName'),
                    field: 'patient.patMiddleName',
                    colId: 'patient.patMiddleName'
                }, {
                    type: 'text',
                    headerName: i18n.tc('grid.patSurname1'),
                    field: 'patient.patSurname1',
                    colId: 'patient.patSurname1'
                }, {
                    type: 'text',
                    headerName: i18n.tc('grid.patSurname2'),
                    field: 'patient.patSurname2',
                    colId: 'patient.patSurname2'
                }
            ]
        }, {
            headerName: i18n.tc('global.petitioner'),
            colId: 'petitioner',
            children: [
                {
                    type: 'text',
                    headerName: i18n.tc('global.doctor'),
                    colId: 'physicianPetitioner.name',
                    field: 'physicianPetitioner.name',
                    cellRenderer: function(params) {
                        if (params && params.data) {
                            return [params.data.physicianPetitioner.name, params.data.physicianPetitioner.middleName, params.data.physicianPetitioner.surname1, params.data.physicianPetitioner.surname2].filter(Boolean).join(' ')
                        }
                    },
                    filterParams: {
                        filterOptions: ['contains'],
                        defaultOption: 'contains',
                        newRowsAction: 'keep'
                    }
                }, {
                    type: 'departments',
                    headerName: i18n.t('global.service'),
                    colId: 'physicianDepartment.name',
                    field: 'physicianDepartment.name',
                    hide: true
                }, {
                    type: 'centers',
                    headerName: i18n.t('global.center'),
                    colId: 'physicianDepartment.center.name',
                    field: 'physicianDepartment.center.name',
                    hide: true
                }
            ]
        }, {
            type: 'text',
            headerName: i18n.t('grid.casCasenumber'),
            colId: 'caseStudy.casCasenumber',
            field: 'caseStudy.casCasenumber',
            hide: true
        }, {
            type: 'text',
            headerName: i18n.t('grid.notYetImplemented'),
            field: 'notYetImplemented',
            valueGetter: () => 'Not Implemented',
            hide: true // TODO notYetImplemented
        }, {
            type: 'laboratories',
            headerName: i18n.t('grid.labName'),
            colId: 'laboratory.labName',
            field: 'laboratory.labName',
            hide: true
        }, {
            type: 'incident',
            headerName: i18n.t('grid.hasAlarms'),
            headerTooltip: i18n.t('grid.hasAlarms'),
            field: 'incidents',
            hide: true,
            onCellClicked: onIncidentClicked,
            colId: 'incidents',
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-exclamation-triangle')
            }
        } */
    ]
}
